module.exports = __webpack_public_path__ + "static/media/image (11).09a2f37b.jpg";